import axios from "axios"

export default {
    namespaced: true,

    state: {
        applications: [],
        technologies: []
    },
    mutations: {
        setApplications(state, array){
            state.applications = array
        },
        setTechnologies(state, array){
            state.technologies = array
        },
        incrementUsage(state, technologyId){
            let index = state.technologies.findIndex(e => e.id == technologyId)
            state.technologies[index].usedBy ++
        },
        decrementUsage(state, technologyId){
            let index = state.technologies.findIndex(e => e.id == technologyId)
            if (state.technologies[index].usedBy > 0){
                state.technologies[index].usedBy --
            }
        },
        setActive(state, applicationId){
            let index = state.applications.findIndex(e => e.id == applicationId)
            state.applications[index].active = true
        },
        setInactive(state, applicationId){
            let index = state.applications.findIndex(e => e.id == applicationId)
            state.applications[index].active = false
        }
    },
    getters: {
        getApplications(state){
            return state.applications
        },
        getTechnologies(state){
            return state.technologies
        },
        getActiveTechnologies(state){
            return state.technologies.filter(t => t.usedBy > 0)
        },
        hasActiveTechnologies(state){
            return state.technologies.some(t => t.usedBy > 0)
        },
        getActiveApplications(state){
            return state.applications.filter(t=> t.active)
        }
    },
    actions: {
        enableApplication(context, applicationId){
            let index = context.state.applications.findIndex(e => e.id == applicationId)
            for (let technology of context.state.applications[index].technologies){
                context.commit('incrementUsage', technology.id)
            }
            context.commit('setActive', applicationId)
        },
        disableApplication(context, applicationId){
            let index = context.state.applications.findIndex(e => e.id == applicationId)
            for (let technology of context.state.applications[index].technologies){
                context.commit('decrementUsage', technology.id)
            }
            context.commit('setInactive', applicationId)
        },
        fetchData(context){
            axios({
                method: "POST",
                data: {
                    query: `{
                        queriedApplications: entries(section: "applications"){
                            id,
                            title
                            ... on applications_applications_Entry {
                                description,
                                usage,
                                image {
                                    url
                                }
                                technologies {
                                    id,
                                    title
                                }
                            }
                        }
                    }`
                }
            }).then(function(res){
                let applications = []
                for (let application of res.data.data.queriedApplications){
                        application.active = false
                        applications.push(application)
                }
                context.commit('setApplications', applications)
            })

            axios({
                method: "POST",
                data: {
                    query: `query {
                        queriedTechnologies: entries(section: "technologies"){
                            id,
                            title,
                            basicRequirement,
                            layer
                        }
                    }`
                }
            }).then(function(res){
                let technologies = []
                for (let technology of res.data.data.queriedTechnologies){
                    technology.usedBy = 0
                    technologies.push(technology)
                }
                context.commit('setTechnologies', technologies)

            })
        }
    }
}